import actionTypes from "./actionTypes";

export const basicUsageReport = data => {
  return {
    type: actionTypes.BASIC_USAGE_REPORT,
    payload: data
  };
};

export const basicUsageReportData = data => {
  return {
    type: actionTypes.BASIC_USAGE_DATA,
    payload: data
  };
};